import { useContext } from 'react';
import { Radio, Space, Table, Tooltip } from 'antd';

import { baseConditionInit, BehaviorContext, conditionInit, itemInit } from 'components/field-behavior/fields';
import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';
import { COLUMN_NAME_WIDTH } from 'lib/styles/number';

import { EditFieldsTableType } from './type';

import styles from './FieldsTable.module.less';

const cx = classnames(styles);
const EditFieldTable: React.FC<EditFieldsTableType> = ({ fieldsData, selectedValue, setSelectedValue }) => {
  const { t } = useI18n();
  const { userOptions, roleOptions, workflowOptions } = useContext(BehaviorContext);
  const options = { user: userOptions, role: roleOptions, status: workflowOptions, action: workflowOptions };

  const onChange = (value, objectId) => {
    console.info(value, objectId);
    setSelectedValue(prevValue => ({
      ...prevValue,
      [objectId]: value,
    }));
  };
  const columns = [
    {
      title: t('pages.fieldBehavior.default.fieldsName'),
      dataIndex: 'field',
      key: 'field',
      width: COLUMN_NAME_WIDTH,
      ellipsis: {
        showTitle: false,
      },
      render: text => {
        let result: React.ReactNode | string = '';
        if (text?.objectId) {
          result = text.name;
        } else {
          result = <div className={cx('del-field')}>{t('pages.fieldBehavior.default.delField')}</div>;
        }
        return (
          <Tooltip placement="top" title={result}>
            {result}
          </Tooltip>
        );
      },
    },
    {
      title: t('global.conditions'),
      key: 'conditionList',
      dataIndex: 'conditionList',
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => {
        return (
          <Radio.Group
            disabled={!record?.field?.objectId}
            onChange={e => onChange(e.target.value, record?.objectId)}
            value={selectedValue?.[record?.objectId]}
          >
            <Space direction="vertical">
              {record?.behavior?.map(item => {
                const id = item.id;
                const result = item?.conditionList?.map((ele, index) =>
                  conditionInit(itemInit(ele, options[ele.type.value]), index),
                );
                return (
                  <Radio key={id} value={id} className={cx('common-item')}>
                    <Tooltip placement="top" title={result}>
                      {result}
                    </Tooltip>
                  </Radio>
                );
              })}
            </Space>
          </Radio.Group>
        );
      },
    },
    {
      title: `${t('pages.fieldBehavior.default.conditionBehavior')}`,
      key: 'fieldBehavior',
      dataIndex: 'fieldBehavior',
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => {
        const results = record?.behavior?.map(item => {
          return baseConditionInit(item?.fieldBehavior || []);
        });
        return (
          <div className={cx('behavior-show-box')}>
            {results?.map((result, index) => (
              <div key={index}>
                <Tooltip placement="top" title={result}>
                  {result || (
                    <span className={cx('condition-text-gray')}>{t('pages.fieldBehavior.default.noCondition')}</span>
                  )}
                </Tooltip>
              </div>
            ))}
          </div>
        );
      },
      width: 300,
    },
  ];

  return (
    <div className={cx('field-wrapper', 'behavior-list')}>
      <div className={cx('field-header')}>{t('pages.fieldBehavior.batch.chooseNeedEditFieldCondition')}</div>
      <Table
        dataSource={fieldsData}
        rowKey="objectId"
        pagination={false}
        columns={columns}
        scroll={{ y: 'calc(100% - 50px)' }}
      />
    </div>
  );
};

export default EditFieldTable;
